import firebase from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDvwM8xJniKjOZjimDkRr_Wo0qn7ltq3IU",
  authDomain: "bad-driver-award.firebaseapp.com",
  databaseURL: "https://bad-driver-award.firebaseio.com",
  projectId: "bad-driver-award",
  storageBucket: "bad-driver-award.appspot.com",
  messagingSenderId: "677344944797",
  appId: "1:677344944797:web:2cb18cb7f292bd1d11ea74",
  measurementId: "G-G3VRKCJL00"
};

firebase.initializeApp(firebaseConfig);

export default firebase